"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withIcon = _interopRequireDefault(require("../withIcon"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const IconWork = props => {
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("svg", {
    viewBox: "0 0 20 19",
    ...props,
    children: /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
      d: "M11.995998,4 L11.995998,2 L7.993997,2 L7.993997,4 L11.995998,4 Z M1.9909955,6 L1.9909955,17 L17.9989995,17 L17.9989995,6 L1.9909955,6 Z M20,4 L20,19 L0,19 L0,4 L5.9929965,4 L5.9929965,2 C5.9929965,0.9 6.89344672,0 7.993997,0 L11.995998,0 C13.0965483,0 13.9969985,0.9 13.9969985,2 L13.9969985,4 L20,4 Z"
    })
  });
};
var _default = exports.default = (0, _withIcon.default)('IconWork')(IconWork);